import { render, staticRenderFns } from "./ConsultarPontosResultado.vue?vue&type=template&id=6ac44c7c&scoped=true"
import script from "./ConsultarPontosResultado.vue?vue&type=script&lang=js"
export * from "./ConsultarPontosResultado.vue?vue&type=script&lang=js"
import style0 from "./ConsultarPontosResultado.vue?vue&type=style&index=0&id=6ac44c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac44c7c",
  null
  
)

export default component.exports